import { createAction, props } from '@ngrx/store';
import { ActionTypes } from './action-types';
import type { AddIntegrationPayload, IntegrationScope } from '../../../../models/integration-settings';

export const addIntegrationAction = createAction(
  ActionTypes.ADD_INTEGRATION,
  props<{ payload: { scope: IntegrationScope, integration: AddIntegrationPayload } }>()
);

export const addIntegrationSuccessAction = createAction(
  ActionTypes.ADD_INTEGRATION_SUCCESS,
  props<{ data: boolean }>()
);

export const addIntegrationFailureAction = createAction(
  ActionTypes.ADD_INTEGRATION_FAILURE,
  props<{ error: unknown }>()
);
